import React from 'react';
import Search from './Search';
import UserInfoTab from './userInfo/UserInfoTab';
import AuditInfoTab from './auditInfo/AuditInfoTab';
import { SetupPage } from 'areas/shared/pages/setup';
import * as Formatter from 'fw/components/formatter/Formatter';
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'
import * as Help from 'modules/app/Help'

class UserSetup extends React.Component {
    render() {
        let opts = {
			setupKey: "userSetup",
            title: "User Setup",
            description: "Create, modify, and remove users",
            addNewTitle: "Add new user",
            helpKey: Help.userSetupHelpKey,
			addPrivilege: App.hasPrivilege("AdminUserSetupAdd"),
			enableColumnSettings: true,
            recentType: "user",
            list: {
                url: API.Security.url('/userSetup/search'),
                rowKey: "userId",
                columns: [
                    { key: 'fullName', name: 'Name', width: 200, sortable: true },
                    { key: 'login', name: 'Login ID', width: 125, sortable: true },
                    { key: 'userTypeDescription', name: 'User Type', width: 125, sortable: false },
                    { key: 'userRoles', name: 'Roles', width: 300, sortable: false },
                    { key: 'phone', name: 'Primary Phone', width: 120 },
                    { key: 'email', name: 'Email' },
                    { key: 'active', name: 'Active', formatter: Formatter.Check, width: 50, cellClass: "text-center" }
                ]
            },
            tabs: [
                { key: "userInfo", title: "User Info", comp: UserInfoTab, helpKey: Help.userSetupInfoHelpKey },
                { key: "auditInfo", title: "Audit Info", comp: AuditInfoTab, helpKey: Help.userSetupAuditHelpKey }
            ]
        };

        return (
            <SetupPage {...opts}
                Search={Search} />
        );
    }
}
export default UserSetup;



// WEBPACK FOOTER //
// ./src/areas/admin/userSetup/UserSetup.js